import React from 'react';

import { InputTextarea } from 'primereact/inputtextarea';
import { withFormikFormControl } from '../FormikFormControl';
import { FormPageFieldComponentProps } from 'types/formPage';
import {wrapComponent, extract} from "../utils";
import BaseInput from "./BaseFields/BaseInput";
import BaseEditor from "./BaseFields/BaseEditor";

export const MultilineText = ( {extraConfig, ...props}: FormPageFieldComponentProps) => {
  const {render_as = ''} = extraConfig
  console.log("MultilineText**", extraConfig, props)
  return render_as === 'editor' ? <BaseEditor {...{extraConfig: {display_as: 'text', ...extraConfig}, ...props}}/> : <BaseInput {...{extraConfig: {display_as: 'textarea', ...extraConfig}, ...props}}/>
};

export const MultilineTextFormik = withFormikFormControl()(MultilineText);

export default MultilineTextFormik;
